define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MBiomassDomain = void 0;
    class MBiomassDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MBiomassDomain._0250, value: "0-250" },
                    { key: MBiomassDomain._250500, value: "250-500" },
                    { key: MBiomassDomain._500750, value: "500-750" },
                    { key: MBiomassDomain._7501000, value: "750-1000" },
                    { key: MBiomassDomain._10001500, value: "1000-1500" },
                    { key: MBiomassDomain._15002500, value: "1500-2500" },
                    { key: MBiomassDomain._2500, value: "2500+" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MBiomassDomain._0250] = 0;
                this.KeyIndex[MBiomassDomain._250500] = 1;
                this.KeyIndex[MBiomassDomain._500750] = 2;
                this.KeyIndex[MBiomassDomain._7501000] = 3;
                this.KeyIndex[MBiomassDomain._10001500] = 4;
                this.KeyIndex[MBiomassDomain._15002500] = 5;
                this.KeyIndex[MBiomassDomain._2500] = 6;
                this.ValueIndex = {};
                this.ValueIndex["0-250"] = 0;
                this.ValueIndex["250-500"] = 1;
                this.ValueIndex["500-750"] = 2;
                this.ValueIndex["750-1000"] = 3;
                this.ValueIndex["1000-1500"] = 4;
                this.ValueIndex["1500-2500"] = 5;
                this.ValueIndex["2500+"] = 6;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MBiomassDomain = MBiomassDomain;
    Object.defineProperty(MBiomassDomain, "_0250", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MBiomassDomain, "_250500", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MBiomassDomain, "_500750", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MBiomassDomain, "_7501000", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MBiomassDomain, "_10001500", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MBiomassDomain, "_15002500", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(MBiomassDomain, "_2500", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 7
    });
    Object.defineProperty(MBiomassDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
